import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import { ConfigSort } from "@usereactify/search";
import React from "react";
import tw from "twin.macro";

const Wrapper = tw.div`
 z-10 focus:outline-none lg:mb-zero
`;

const SortBy = withFocusRing(tw.select`
  bg-neutral cursor-pointer font-body text-hint
`);

type FilterSectionSortProps = {
  sortOptions: ConfigSort[];
  setSortOption: (handle: string) => void;
  scrollTo: (i: number, j: any, k: number) => void;
};
export const FilterSectionSort = ({
  sortOptions,
  setSortOption,
  scrollTo,
}: FilterSectionSortProps) => {
  return (
    <Wrapper>
      <SortBy
        data-testid={"sort-header-title"}
        onChange={(e) => {
          setSortOption(e.target.value);
          scrollTo(0, null, 1000);
        }}
      >
        {sortOptions?.map((option) => (
          <option key={option.id} value={option.handle}>
            {option.name}
          </option>
        ))}
      </SortBy>
    </Wrapper>
  );
};
